export default __webpack_public_path__ + "static/media/gem_grey.73459531.png";